import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Moment from 'moment';
import Drawer from '../../Common/Drawer/Drawer';
import InputText from '../../Common/InputText';
import { DATE_FORMAT } from '../../../constants/constants';

export class CalculateDatesDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            showError: false,
            error: ''
        };
    }

    onFormChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        this.props.onTaskChange(name, value);
    }

    onCancel = () => {
        this.props.onCancel();
    }

    onSave = () => {
        this.setState({ showError: false });
        let startDate = this.props.task.startDate;
        let startDaysOut = this.props.task.startDaysOut;
        let targetDate = this.props.task.targetDate;
        let targetDaysOut = this.props.task.targetDaysOut;
        let openingDate = Moment.utc(this.props.locationOpeningDate);

        const targetWeeks = Number.parseInt(this.props.task.targetWeeks);
        const targetDays = Number.parseInt(this.props.task.targetDays);
        if (isNaN(targetWeeks) || isNaN(targetDays)) {
            this.setState({ showError: true, error: "Unable to parse target weeks or days values" });
            return;
        }
        targetDaysOut = (targetWeeks * 7) + targetDays;
        targetDate = Moment(openingDate).subtract(targetDaysOut, "days").format(DATE_FORMAT);

        if (this.props.isStartDateActive) {
            const startWeeks = Number.parseInt(this.props.task.startWeeks);
            const startDays = Number.parseInt(this.props.task.startDays);
            if (isNaN(startWeeks) || isNaN(startDays)) {
                this.setState({ showError: true, error: "Unable to parse start weeks or days values" });
                return;
            }
            startDaysOut = (startWeeks * 7) + startDays;
            startDate = Moment(openingDate).subtract(startDaysOut, "days").format(DATE_FORMAT);

            if (startDaysOut < targetDaysOut) {
                this.setState({ showError: true, error: "Start Date must be before Target Date" });
                return;
            }
        }

        this.props.onComplete(startDaysOut, startDate, targetDaysOut, targetDate);
    }

    render() {
        /**
         * 1535: 
         * This component is only shown if the subscription does not have the
         * project feature enabled.  As such, the below date labels always
         * refer to opening, instead of ZeroDate
         */
        const title = (this.props.isStartDateActive) ? "Calculate Dates" : "Calculate Target Date";
        return (
            <Drawer isWide={false} title={title}
                onSaveClick={this.onSave}
                saveText='Calculate'
                onCancelClick={this.onCancel}
            >
                <div>
                    {
                        this.state.showError &&
                        <div className="row">
                            <div className="col-11 alert-danger p-2 m-2 rounded">
                                {this.state.error}
                            </div>
                        </div>
                    }
                    {
                        this.props.isStartDateActive &&
                        <div>
                            <div className="row">
                                <div className="col-12"><label>Start Date - Weeks/Days prior to opening</label></div>
                            </div>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <InputText name="startWeeks" label="Weeks" type="number" placeholder="Weeks" 
                                                value={this.props.task.startWeeks.toString()} 
                                                onChange={this.onFormChange} />
                                        </td>
                                        <td className="td-spacer"></td>
                                        <td>
                                            <InputText name="startDays" label="Days" type="number" placeholder="Days"
                                                value={this.props.task.startDays.toString()}
                                                onChange={this.onFormChange} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    }

                    <div className="row">
                        <div className="col-12"><label>Target Date - Weeks/Days prior to opening</label></div>
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <InputText name="targetWeeks" label="Weeks" type="number" placeholder="Weeks"
                                        value={this.props.task.targetWeeks.toString()}
                                        onChange={this.onFormChange} />
                                </td>
                                <td className="td-spacer"></td>
                                <td>
                                    <InputText name="targetDays" label="Days" type="number" placeholder="Days"
                                        value={this.props.task.targetDays.toString()}
                                        onChange={this.onFormChange} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Drawer>
        )
    }
}

CalculateDatesDrawer.propTypes = {
    task: PropTypes.object.isRequired,
    locationOpeningDate: PropTypes.string.isRequired,
    isStartDateActive: PropTypes.bool.isRequired,
    onTaskChange: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default CalculateDatesDrawer;
